// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.DropDownItem[data-v-eebd6fa4] {\n  width: 100%;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.DropDownItem[data-v-eebd6fa4] > span {\n  gap: 1rem;\n  padding: 0.5rem 1rem;\n  width: 100%;\n  font-weight: 400;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
